let swiperhasLoaded = false;

const shouldDestroy = (device) => {
  if (device == null) {
    return false;
  }
  let res = false;
  const windowWidth = window.screen.availWidth;
  if (device === "mobile") {
    res = windowWidth <= 768;
  } else if (device === "pc") {
    res = windowWidth > 768;
  }
  return res;
};

class TestimonialSldier extends HTMLElement {
  #randNumber = Math.floor(Math.random() * 10000);
  #swiperInitialized = false;
  #breakOn = null;
  #swiper = null;
  #itemsPerRow = 3;
  #itemsPerRowMobile = 1;

  constructor() {
    super();

    // console.log("Ja se ucitavam");
    this.#breakOn = this.dataset.breakOn || null;
    this.#itemsPerRow = this.dataset.slidesPerView;
    this.#itemsPerRowMobile = this.dataset.slidesPerViewMobile;

    window.addEventListener("swiper-loaded", () => {
      this.initSwiper();
    });

    window.addEventListener("resize", () => {
      this.initSwiper();
    });

    this.#swiperInitialized == false &&
      swiperhasLoaded == true &&
      this.initSwiper();
  }
  initSwiper() {
    const swiperWrapper = this.querySelector(".swiper-wrapper.swiper-disabled");
    const slides = this.querySelectorAll("featured-testimonial");
    if (shouldDestroy(this.#breakOn) && window.screen.availWidth > 1249) {
      // console.log("Swiper shouldn't be displayed on " + this.#breakOn);
      if (this.#swiper !== null) {
        // console.log("Destroying swiper");
        this.#swiper.destroy(true, true);
      }

      slides.forEach((slide) => slide.classList.remove("swiper-slide"));

      if (!swiperWrapper) {
        this.querySelector(".swiper-wrapper").classList.add("swiper-disabled");
      }

      this.#swiperInitialized = false;
      //   const prevArrow = this.querySelector(".swiper-button-prev");
      //   const nextArrow = this.querySelector(".swiper-button-next");

      return;
    }
    //check if swiper is already initialized
    if (this.#swiperInitialized) {
      return;
    }

    // Check if wrapper exist, if it doesn't (because it was deleted, add it)
    if (swiperWrapper) {
      swiperWrapper.classList.remove("swiper-disabled");
    }
    slides.forEach((slide) => slide.classList.add("swiper-slide"));

    // console.log("Initialized swiper for Testimonials");
    this.querySelector(".testimonial-slider__slider").classList.add(
      `swiper-number-${this.#randNumber}`
    );
    const prevArrow = this.querySelector(".swiper-button-prev");
    const nextArrow = this.querySelector(".swiper-button-next");
    prevArrow.classList.add(`prev-arrow-${this.#randNumber}`);
    nextArrow.classList.add(`next-arrow-${this.#randNumber}`);

    this.#swiper = new Swiper(`.swiper-number-${this.#randNumber}`, {
      slidesPerView: 1,
      speed: 400,
      centerSlides: true,
      spaceBetween: 10,
      navigation: {
        nextEl: `.next-arrow-${this.#randNumber}`,
        prevEl: `.prev-arrow-${this.#randNumber}`,
      },
      breakpoints: {
        769: {
          slidesPerView: 2.1,
        },
        1250: {
          slidesPerView: this.#itemsPerRow,
          spaceBetween: 88,
        },
      },
    });
    this.#swiperInitialized = true;
  }
}

customElements.define("testimonial-slider", TestimonialSldier);

function swiperLoaded() {
  // console.log("Test swiper");
  swiperhasLoaded = true;
  window.dispatchEvent(new Event("swiper-loaded"), { bubbles: true });
}

class DropdownElement extends HTMLElement {
  #collapsed = true;
  #contentHeightEl;
  #dropdownContent;
  static dropdownsHeaderHeights = [];
  constructor() {
    super();
    this.#collapsed = this.dataset.collapsed == "true" ? true : false;
    DropdownElement.dropdownsHeaderHeights.push(
      this.querySelector(".dropdown__header")
    );
    this.#contentHeightEl = this.querySelector(".dropdown__content-for-anim");
    this.#dropdownContent = this.querySelector(".dropdown__content");

    this.initDropdownLogic();

    if (window.screen.availWidth > 769) {
      DropdownElement.dropdownsHeaderHeights.forEach((el) => {
        this.#collapsed = false;
        this.dataset.collapsed = this.#collapsed.toString();
      });
    }
    document.addEventListener("DOMContentLoaded", () => {
      this.#dropdownContent.style.height = this.#collapsed
        ? "0px"
        : `${this.#contentHeightEl.offsetHeight}px`;
    });
    window.addEventListener("resize", () => {
      this.#dropdownContent.style.height = this.#collapsed
        ? "0px"
        : `${this.#contentHeightEl.offsetHeight}px`;
    });
  }

  initDropdownLogic() {
    const header = this.querySelector(".dropdown__header");

    header.addEventListener("click", () => {
      this.#collapsed = !this.#collapsed;
      this.dataset.collapsed = this.#collapsed.toString();
      this.#dropdownContent.style.height = this.#collapsed
        ? "0px"
        : `${this.#contentHeightEl.offsetHeight}px`;
    });
  }
}

customElements.define("dropdown-element", DropdownElement);

class Multicolumn extends HTMLElement {
  #randNumber = Math.floor(Math.random() * 10000);
  #swiperInitialized = false;
  #breakOn = null;
  #swiper = null;
  #itemsPerRow = 3;
  #itemsPerRowMobile = 1;

  constructor() {
    super();

    // console.log("Ja se ucitavam");
    this.#breakOn = this.dataset.breakOn || null;
    this.#itemsPerRow = this.dataset.slidesPerView;
    this.#itemsPerRowMobile = this.dataset.slidesPerViewMobile;

    // console.log(this.#itemsPerRow);

    window.addEventListener("swiper-loaded", () => {
      this.initSwiper();
    });

    window.addEventListener("resize", () => {
      this.initSwiper();
    });

    this.#swiperInitialized == false &&
      swiperhasLoaded == true &&
      this.initSwiper();
  }
  initSwiper() {
    const swiperWrapper = this.querySelector(".swiper-wrapper.swiper-disabled");
    const slides = this.querySelectorAll("column");
    if (
      shouldDestroy(this.#breakOn) &&
      this.#breakOn == "pc" &&
      window.screen.availWidth > 1199
    ) {
      // console.log("Swiper shouldn't be displayed on " + this.#breakOn);
      if (this.#swiper !== null) {
        // console.log("Destroying swiper");
        this.#swiper.destroy(true, true);
      }

      slides.forEach((slide) => slide.classList.remove("swiper-slide"));

      if (!swiperWrapper) {
        this.querySelector(".swiper-wrapper").classList.add("swiper-disabled");
      }

      this.#swiperInitialized = false;

      return;
    }
    //check if swiper is already initialized
    if (this.#swiperInitialized) {
      return;
    }

    // Check if wrapper exist, if it doesn't (because it was deleted, add it)
    if (swiperWrapper) {
      swiperWrapper.classList.remove("swiper-disabled");
    }
    slides.forEach((slide) => slide.classList.add("swiper-slide"));

    // console.log("Initialized swiper for Multicolumn");
    this.classList.add(`swiper-number-${this.#randNumber}`);
    const prevArrow = this.querySelector(".swiper-button-prev");
    const nextArrow = this.querySelector(".swiper-button-next");
    prevArrow.classList.add(`prev-arrow-${this.#randNumber}`);
    nextArrow.classList.add(`next-arrow-${this.#randNumber}`);
    // prevArrow.style.display = "none";
    // nextArrow.style.display = "none";

    const image = this.querySelector(".featured-image img");
    if (image) {
      const imageHeight = image.offsetHeight;
      nextArrow.style.top = imageHeight / 2 + "px";
      prevArrow.style.top = imageHeight / 2 + "px";
    }

    this.#swiper = new Swiper(`.swiper-number-${this.#randNumber}`, {
      slidesPerView: this.#itemsPerRowMobile,
      speed: 400,
      centerSlides: true,
      spaceBetween: 20,
      autoHeight: true,
      navigation: {
        nextEl: `.next-arrow-${this.#randNumber}`,
        prevEl: `.prev-arrow-${this.#randNumber}`,
      },
      breakpoints: {
        769: {
          slidesPerView: 2.2,
          autoHeight: false,
        },
        1200: {
          slidesPerView: this.#itemsPerRow,
          spaceBetween: 21,
          autoHeight: false,
        },
      },
    });
    this.#swiperInitialized = true;
  }
}

customElements.define("multicolumn-section", Multicolumn);

class ProtocolSlider extends HTMLElement {
  #randNumber = Math.floor(Math.random() * 10000);
  #swiperInitialized = false;
  #breakOn = null;
  #swiper = null;
  #itemsPerRow = 3;
  #itemsPerRowMobile = 1;

  constructor() {
    super();

    // console.log("Ja se ucitavam");
    this.#breakOn = this.dataset.breakOn || null;
    this.#itemsPerRow = this.dataset.slidesPerView;
    this.#itemsPerRowMobile = this.dataset.slidesPerViewMobile;

    // console.log(this.#itemsPerRow);

    window.addEventListener("swiper-loaded", () => {
      this.initSwiper();
    });

    window.addEventListener("resize", () => {
      this.initSwiper();
    });

    this.#swiperInitialized == false &&
      swiperhasLoaded == true &&
      this.initSwiper();
  }
  initSwiper() {
    const swiperWrapper = this.querySelector(".swiper-wrapper.swiper-disabled");
    const slides = this.querySelectorAll("column");
    if (shouldDestroy(this.#breakOn)) {
      // console.log("Swiper shouldn't be displayed on " + this.#breakOn);
      if (this.#swiper !== null) {
        // console.log("Destroying swiper");
        this.#swiper.destroy(true, true);
      }

      slides.forEach((slide) => slide.classList.remove("swiper-slide"));

      if (!swiperWrapper) {
        this.querySelector(".swiper-wrapper").classList.add("swiper-disabled");
      }

      this.#swiperInitialized = false;

      return;
    }
    //check if swiper is already initialized
    if (this.#swiperInitialized) {
      return;
    }

    // Check if wrapper exist, if it doesn't (because it was deleted, add it)
    if (swiperWrapper) {
      swiperWrapper.classList.remove("swiper-disabled");
    }
    slides.forEach((slide) => slide.classList.add("swiper-slide"));

    // console.log("Initialized swiper for Protocol Slider");
    this.classList.add(`swiper-number-${this.#randNumber}`);
    const prevArrow = this.querySelector(".swiper-button-prev");
    const nextArrow = this.querySelector(".swiper-button-next");
    prevArrow.classList.add(`prev-arrow-${this.#randNumber}`);
    nextArrow.classList.add(`next-arrow-${this.#randNumber}`);

    const pagination = document.querySelector(".swiper-pagination");
    pagination.classList.add(`swiper-pagination-${this.#randNumber}`);

    this.#swiper = new Swiper(`.swiper-number-${this.#randNumber}`, {
      slidesPerView: 1.2,
      speed: 400,
      centerSlides: true,
      spaceBetween: 10,
      pagination: {
        el: `.swiper-pagination-${this.#randNumber}`,
        type: "bullets",
      },
      breakpoints: {
        769: {
          slidesPerView: this.#itemsPerRow,
          navigation: {
            nextEl: `.next-arrow-${this.#randNumber}`,
            prevEl: `.prev-arrow-${this.#randNumber}`,
          },
        },
      },
    });
    this.#swiperInitialized = true;
  }
}

customElements.define("protocol-slider", ProtocolSlider);

// Megamenu icons
document.addEventListener("DOMContentLoaded", () => {
  let biggestHeight = 0;
  const megaMenuLinks = document.querySelectorAll(".mega-menu__linklist");
  if (window.screen.availWidth < 799) return;

  megaMenuLinks.forEach((link) => {
    // console.log(link);
    if (biggestHeight < link.offsetHeight) {
      biggestHeight = link.offsetHeight;
    }
  });

  // console.log(biggestHeight);
  megaMenuLinks.forEach((link) => {
    link.style.height = biggestHeight + "px";
  });
});

class ProtocolItem extends HTMLElement {
  #blockId = "";
  #dropdownCollapsed = true;
  #dropdown = null;
  static allDropdowns = [];
  constructor() {
    super();

    this.#blockId = this.dataset.productBlock;
    this.#dropdown = this.querySelector(".produc-item__dropdown");
    ProtocolItem.allDropdowns.push(this.#dropdown);
    this.#dropdownCollapsed =
      this.#dropdown.dataset.collapsed == "true" ? true : false;

    this.dropdownLogic();
  }

  dropdownLogic() {
    this.#dropdown.addEventListener("click", () => {
      this.#dropdownCollapsed =
        this.#dropdown.dataset.collapsed == "true" ? true : false;

      const protcolProducts =
        this.closest("section").querySelectorAll(".protocol-product");
      if (this.#dropdownCollapsed) {
        ProtocolItem.allDropdowns.forEach((dropdownEl) => {
          dropdownEl.setAttribute("data-collapsed", "true");
        });
        this.#dropdownCollapsed = false;
        this.#dropdown.setAttribute("data-collapsed", this.#dropdownCollapsed);

        protcolProducts.forEach((product) => {
          product.dataset.productBlock == this.#blockId
            ? (product.dataset.isSelected = true)
            : (product.dataset.isSelected = false);
        });
      } else {
        this.#dropdownCollapsed = true;
        this.#dropdown.setAttribute("data-collapsed", this.#dropdownCollapsed);
        protcolProducts.forEach((product) => {
          product.dataset.isSelected = false;
        });
      }
    });
  }
}

customElements.define("protocol-item", ProtocolItem);

class ProductDescription extends HTMLElement {
  #isCollapsed = true;
  #dropdown;
  constructor() {
    super();
    this.#dropdown = this.querySelector(".product-desc-header");
    if (!this.#dropdown) {
      return;
    }
    this.#isCollapsed =
      this.#dropdown.dataset.collapsed == "true" ? true : false;

    this.#dropdown.addEventListener("click", () => {
      this.#isCollapsed = !this.#isCollapsed;
      this.#dropdown.dataset.collapsed = this.#isCollapsed;
    });
  }
}

customElements.define("product-description", ProductDescription);

class DropdownSlider extends HTMLElement {
  #randNumber = Math.floor(Math.random() * 10000);
  #swiperInitialized = false;
  #breakOn = null;
  #swiper = null;
  #itemsPerRow = 3;
  #itemsPerRowMobile = 1;
  #parent = null;
  #selectedBlock = null;
  #imageHeight = 0;
  constructor() {
    super();

    // console.log("Ja se ucitavam");
    this.#breakOn = this.dataset.breakOn || null;
    this.#itemsPerRow = this.dataset.slidesPerView;
    this.#itemsPerRowMobile = this.dataset.slidesPerViewMobile;

    // console.log(this.#itemsPerRow);

    window.addEventListener("swiper-loaded", () => {
      this.initLogic();
    });

    window.addEventListener("resize", () => {
      this.initSwiper();
    });

    this.#swiperInitialized == false &&
      swiperhasLoaded == true &&
      this.initLogic();

    this.#parent = this.closest(".dropdown-slider-section");
    this.dropdownHeaderListener();
  }
  initSwiper() {
    const swiperWrapper = this.querySelector(".swiper-wrapper.swiper-disabled");
    const slides = this.querySelectorAll("column");

    if (shouldDestroy(this.#breakOn)) {
      // console.log("Swiper shouldn't be displayed on " + this.#breakOn);
      if (this.#swiper !== null) {
        // console.log("Destroying swiper");
        this.#swiper.destroy(true, true);
      }

      slides.forEach((slide) => slide.classList.remove("swiper-slide"));

      if (!swiperWrapper) {
        this.querySelector(".swiper-wrapper").classList.add("swiper-disabled");
      }

      this.#swiperInitialized = false;

      return;
    }
    //check if swiper is already initialized
    if (this.#swiperInitialized) {
      return;
    }

    // Check if wrapper exist, if it doesn't (because it was deleted, add it)
    if (swiperWrapper) {
      swiperWrapper.classList.remove("swiper-disabled");
    }
    slides.forEach((slide) => slide.classList.add("swiper-slide"));

    // console.log("Initialized swiper for Drpdown Swiper");
    this.classList.add(`swiper-number-${this.#randNumber}`);
    const prevArrow = this.querySelector(".swiper-button-prev");
    const nextArrow = this.querySelector(".swiper-button-next");
    prevArrow.classList.add(`prev-arrow-${this.#randNumber}`);
    nextArrow.classList.add(`next-arrow-${this.#randNumber}`);

    const image = this.querySelector(".dropdown-element  img");

    if (image) {
      this.#imageHeight =
        image.offsetHeight > 0 ? image.offsetHeight : this.#imageHeight;
      nextArrow.style.top = this.#imageHeight / 2 + "px";
      prevArrow.style.top = this.#imageHeight / 2 + "px";
    }

    window.addEventListener("resize", () => {
      if (image) {
        this.#imageHeight =
          image.offsetHeight > 0 ? image.offsetHeight : this.#imageHeight;
        nextArrow.style.top = this.#imageHeight / 2 + "px";
        prevArrow.style.top = this.#imageHeight / 2 + "px";
      }
    });

    this.#swiper = new Swiper(`.swiper-number-${this.#randNumber}`, {
      slidesPerView: 1,
      speed: 400,
      centerSlides: true,
      spaceBetween: 10,
      navigation: {
        nextEl: `.next-arrow-${this.#randNumber}`,
        prevEl: `.prev-arrow-${this.#randNumber}`,
      },
      breakpoints: {
        769: {
          slidesPerView: this.#itemsPerRow,
        },
        1250: {
          spaceBetween: 77,
        },
      },
    });
    this.#swiperInitialized = true;
  }

  initLogic() {
    this.style.display = "none";
    this.#swiper && this.#swiper.destroy(true, true);
    this.#swiperInitialized = false;
    const sliders = this.querySelectorAll(".swiper-slide");

    sliders.forEach((slide) => {
      if (slide.dataset.id != this.#parent.dataset.selectedBlock) {
        slide.style.display = "none";
      }
    });
    if (window.screen.availWidth < 769) {
      const activeHeaderBox = this.#parent.querySelector(
        `dropdown-header[data-for="${
          this.#parent.dataset.selectedBlock
        }"] ~ .mobile-section-container `
      );
      activeHeaderBox.appendChild(this);
    }
    this.style.display = "flex";
    this.initSwiper();
  }
  dropdownHeaderListener() {
    this.#parent.addEventListener("dropdown-changed", () => {
      if (this.#parent.dataset.selectedBlock === "") {
        this.style.display = "none";
        this.#swiper && this.#swiper.destroy(true, true);
        this.#swiperInitialized = false;
      } else {
        this.initLogic();
      }
    });
  }
}
customElements.define("dropdown-slider", DropdownSlider);

class DropdownHeader extends HTMLElement {
  #dropdownCollapsed = true;
  #blockId = "";
  #parent = null;
  static allDropdowns = [];
  constructor() {
    super();
    this.#dropdownCollapsed = this.dataset.collapsed == "true" ? true : false;
    DropdownHeader.allDropdowns.push(this);
    this.#parent = this.closest(".dropdown-slider-section");
    this.#blockId = this.dataset.for;
    this.dropdownLogic();
  }

  dropdownLogic() {
    this.addEventListener("click", () => {
      this.#dropdownCollapsed = this.dataset.collapsed == "true" ? true : false;
      if (this.#dropdownCollapsed) {
        DropdownHeader.allDropdowns.forEach((dropdownEl) => {
          dropdownEl.setAttribute("data-collapsed", "true");
        });
        this.#dropdownCollapsed = false;
        this.setAttribute("data-collapsed", this.#dropdownCollapsed);
        this.#parent.dataset.selectedBlock = this.#blockId;
        this.parentEvent(true);
        this.scrollIntoView();
      } else {
        this.#dropdownCollapsed = true;
        this.setAttribute("data-collapsed", this.#dropdownCollapsed);
        this.#parent.dataset.selectedBlock = "";
        this.parentEvent(false);
      }
    });
  }

  parentEvent(isSelected) {
    this.#parent.dispatchEvent(new CustomEvent("dropdown-changed"));
  }
}

customElements.define("dropdown-header", DropdownHeader);

document.addEventListener("DOMContentLoaded", () => {
  let interval = setInterval(() => {
    if (document.querySelectorAll(".sezzle-button-text").length > 0) {
      document.querySelectorAll(".sezzle-button-text").forEach((el) => {
        el.innerHTML = `4 easy payments with Sezzle`;
        el.closest(".sezzle-shopify-info-button").classList.add("initialized");
      });
    }
    clearInterval(interval);
  }, 200);
});

class IngredientsModal extends HTMLElement {
  #opened = false;
  #linkClicked = true;
  constructor() {
    super();
    this.#opened = this.dataset.opened;

    document.body.addEventListener("click", (e) => {
      if (
        this.#opened &&
        !this.contains(e.target) &&
        this !== e.target &&
        !this.#linkClicked
      ) {
        this.setState(false);
      }
    });
  }
  setState(state, linkClicked = false) {
    this.#opened = state;
    this.dataset.opened = state;
    this.#linkClicked = linkClicked;
    if (linkClicked) {
      setTimeout(() => {
        this.#linkClicked = false;
      }, 200);
    }
  }
}

customElements.define("ingredient-modal", IngredientsModal);

document.body.querySelectorAll(`a[data-open-popup]`).forEach((button) => {
  button.addEventListener("click", (e) => {
    e.preventDefault();
    const selector = button.dataset.openPopup;
    const popup = document.querySelector(selector);
    if (!popup) {
      console.error("Couldn't select the popup with selector: ", selector);
      return;
    }
    popup.setState(true, true);
  });
});

//footer menu mobile
const footerLinksHeaders = document.querySelectorAll(
  "footer .block__link-list .footer__heading"
);
footerLinksHeaders.forEach((linkHeader) => {
  linkHeader.addEventListener("click", () => {
    linkHeader.dataset.collapsed =
      linkHeader.dataset.collapsed == "true"
        ? (linkHeader.dataset.collapsed = "false")
        : (linkHeader.dataset.collapsed = "true");
  });
});

document.addEventListener("DOMContentLoaded", () => {
  const mobileFilterTriggerOpen = document.querySelector('.js-mobile-filters-trigger-open');
  const mobileFiltersTriggerClose = document.querySelector('.js-mobile-filters-trigger-close');
  const mobileFilters = document.querySelector('.js-collection-filters');

  if(!mobileFilterTriggerOpen || !mobileFilters || !mobileFiltersTriggerClose) return;
  mobileFilterTriggerOpen.addEventListener("click", () => {
    mobileFilters.classList.add('active');s
  })
  mobileFiltersTriggerClose.addEventListener("click", () => {
    mobileFilters.classList.remove('active');
  })
});


class ArticlesSlider extends HTMLElement {
  #randNumber = Math.floor(Math.random() * 10000);
  #swiperInitialized = false;
  #breakOn = null;
  #swiper = null;
  #itemsPerRow = 3;
  #itemsPerRowMobile = 1;
  #initialSlide = 0;

  constructor() {
    super();

    this.#breakOn = this.dataset.breakOn || null;
    this.#itemsPerRow = this.dataset.slidesPerView;
    this.#itemsPerRowMobile = this.dataset.slidesPerViewMobile;
    this.#initialSlide = this.dataset.initialSlide;

    window.addEventListener("swiper-loaded", () => {
      this.initSwiper();
    });

    window.addEventListener("resize", () => {
      this.initSwiper();
    });

    this.#swiperInitialized == false &&
      swiperhasLoaded == true &&
      this.initSwiper();
  }
  initSwiper() {
    const swiperWrapper = this.querySelector(".swiper-wrapper.swiper-disabled");
    const slides = this.querySelectorAll("featured-article");
    if (shouldDestroy(this.#breakOn) && window.screen.availWidth > 1249) {
      if (this.#swiper !== null) {
        this.#swiper.destroy(true, true);
      }

      slides.forEach((slide) => slide.classList.remove("swiper-slide"));

      if (!swiperWrapper) {
        this.querySelector(".swiper-wrapper").classList.add("swiper-disabled");
      }

      this.#swiperInitialized = false;

      return;
    }
    if (this.#swiperInitialized) {
      return;
    }

    if (swiperWrapper) {
      swiperWrapper.classList.remove("swiper-disabled");
    }
    slides.forEach((slide) => slide.classList.add("swiper-slide"));

    this.querySelector(".articles-slider__slider").classList.add(
      `swiper-number-${this.#randNumber}`
    );

    // console.log("ASDKUH");
    // console.log(this.#itemsPerRowMobile);
    // console.log(this.#itemsPerRow);
    this.#swiper = new Swiper(`.swiper-number-${this.#randNumber}`, {
      slidesPerView: this.#itemsPerRowMobile,
      speed: 400,
      centerSlides: false,
      spaceBetween: 18,
      initialSlide: this.#initialSlide,
      breakpoints: {
        769: {
          slidesPerView: this.#itemsPerRowMobile,
        },
        1250: {
          slidesPerView: this.#itemsPerRow,
        },
      },
    });
    this.#swiperInitialized = true;
  }
}

customElements.define("articles-slider", ArticlesSlider);
class IngredientsSlider extends HTMLElement {
  #randNumber = Math.floor(Math.random() * 10000);
  #swiperInitialized = false;
  #breakOn = null;
  #swiper = null;
  #itemsPerRow = 3;
  #itemsPerRowMobile = 1;
  #initialSlide = 0;

  constructor() {
    super();

    this.#breakOn = this.dataset.breakOn || null;
    this.#itemsPerRow = this.dataset.slidesPerView;
    this.#itemsPerRowMobile = this.dataset.slidesPerViewMobile;
    this.#initialSlide = this.dataset.initialSlide;

    window.addEventListener("swiper-loaded", () => {
      this.initSwiper();
    });

    window.addEventListener("resize", () => {
      this.initSwiper();
    });

    this.#swiperInitialized == false &&
      swiperhasLoaded == true &&
      this.initSwiper();
  }
  initSwiper() {
    const swiperWrapper = this.querySelector(".swiper-wrapper.swiper-disabled");
    const slides = this.querySelectorAll(".ingredient");
    if (shouldDestroy(this.#breakOn) && window.screen.availWidth > 999) {
      if (this.#swiper !== null) {
        this.#swiper.destroy(true, true);
      }

      slides.forEach((slide) => slide.classList.remove("swiper-slide"));

      if (!swiperWrapper) {
        this.querySelector(".swiper-wrapper").classList.add("swiper-disabled");
      }

      this.#swiperInitialized = false;

      return;
    }
    if (this.#swiperInitialized) {
      return;
    }

    if (swiperWrapper) {
      swiperWrapper.classList.remove("swiper-disabled");
    }
    slides.forEach((slide) => slide.classList.add("swiper-slide"));

    this.querySelector(".ingredients-slider__slider").classList.add(
      `swiper-number-${this.#randNumber}`
    );

    this.#swiper = new Swiper(`.swiper-number-${this.#randNumber}`, {
      slidesPerView: this.#itemsPerRowMobile,
      speed: 400,
      centerSlides: false,
      spaceBetween: 13,
      initialSlide: this.#initialSlide,
      slidesOffsetBefore: 13,
      breakpoints: {
        769: {
          slidesPerView: this.#itemsPerRowMobile,
        },
        1000: {
          slidesPerView: this.#itemsPerRow,
          slidesOffsetBefore: 84,
        },
      },
    });
    this.#swiperInitialized = true;
  }
}

customElements.define("ingredients-slider", IngredientsSlider);

class IngredientsSection extends HTMLElement {
  constructor() {
    super();

    this.selectors = this.querySelectorAll('[data-selector]');
    this.sliders = this.querySelectorAll("ingredients-slider");
    this.modalContents = document.querySelectorAll(".ingredient-modal-content"); // modal content is outside this element

    this.selectors.forEach((selector) => {
      selector.addEventListener("click", () => {
        this.changeSlider(selector);
      });
    });
  }

  changeSlider(selector) {
    if (!selector) return;

    const targetIndex = selector.dataset.targetListIndex;

    // Handle slider section
    const selectedSlide = this.querySelector('ingredients-slider.visible');
    const targetSlide = this.querySelector(`ingredients-slider[data-list-index="${targetIndex}"]`);
    const selectedSelector = this.querySelector(".ingredient-list-selector-wrapper.selected");

    if (selectedSelector) selectedSelector.classList.remove('selected');
    selector.classList.add('selected');

    if (selectedSlide) selectedSlide.classList.remove('visible');
    if (targetSlide) targetSlide.classList.add('visible');

    // Handle modal content outside this section
    this.modalContents.forEach(modal => {
      modal.classList.toggle('visible', modal.dataset.listIndex === targetIndex);
    });
  }
}

customElements.define('ingredients-section', IngredientsSection);



class GuideSlider extends HTMLElement {
  #randNumber = Math.floor(Math.random() * 10000);
  #swiperInitialized = false;
  #breakOn = null;
  #swiper = null;
  #itemsPerRow = 3;
  #itemsPerRowMobile = 1;
  #initialSlide = 0;

  constructor() {
    super();

    this.#breakOn = this.dataset.breakOn || null;
    this.#itemsPerRow = this.dataset.slidesPerView;
    this.#itemsPerRowMobile = this.dataset.slidesPerViewMobile;
    this.#initialSlide = this.dataset.initialSlide;

    window.addEventListener("swiper-loaded", () => {
      this.initSwiper();
    });

    window.addEventListener("resize", () => {
      this.initSwiper();
    });

    this.#swiperInitialized == false &&
      swiperhasLoaded == true &&
      this.initSwiper();
  }
  initSwiper() {
    const swiperWrapper = this.querySelector(".swiper-wrapper.swiper-disabled");
    const slides = this.querySelectorAll(".step");
    if (shouldDestroy(this.#breakOn) && window.screen.availWidth > 999) {
      if (this.#swiper !== null) {
        this.#swiper.destroy(true, true);
      }

      slides.forEach((slide) => slide.classList.remove("swiper-slide"));

      if (!swiperWrapper) {
        this.querySelector(".swiper-wrapper").classList.add("swiper-disabled");
      }

      this.#swiperInitialized = false;

      return;
    }
    if (this.#swiperInitialized) {
      return;
    }

    if (swiperWrapper) {
      swiperWrapper.classList.remove("swiper-disabled");
    }
    slides.forEach((slide) => slide.classList.add("swiper-slide"));

    this.querySelector(".guide-slider__slider").classList.add(
      `swiper-number-${this.#randNumber}`
    );

    this.#swiper = new Swiper(`.swiper-number-${this.#randNumber}`, {
      slidesPerView: this.#itemsPerRowMobile,
      speed: 400,
      centerSlides: false,
      spaceBetween: 18,
      initialSlide: this.#initialSlide,
      slidesOffsetBefore: 13,
      breakpoints: {
        769: {
          slidesPerView: this.#itemsPerRowMobile,
        },
        1000: {
          slidesPerView: this.#itemsPerRow,
          slidesOffsetBefore: 84,
        },
      },
    });
    this.#swiperInitialized = true;
  }
}

customElements.define("guide-slider", GuideSlider);

function initGoaRedSciAccPanels() {
  var containers = document.querySelectorAll('[data-goa-red-sci-acc]');
  containers.forEach(function (container) {
    var triggers = container.querySelectorAll('label.goa-red-sci-acc__trigger');
    for (var i = 0; i < triggers.length; i++) {
      if (triggers[i].dataset.goaRsaPanelInit === '1') continue;
      triggers[i].dataset.goaRsaPanelInit = '1';
      triggers[i].addEventListener('click', function (e) {
        e.preventDefault();
        var isActive = this.classList.contains('active');
        // Close all in this container
        triggers.forEach(function (t) {
          t.classList.remove('active');
          var p = t.nextElementSibling;
          if (p && p.classList.contains('goa-red-sci-acc__panel')) p.style.maxHeight = null;
        });
        // Open clicked if it wasn't already active
        if (!isActive) {
          this.classList.add('active');
          var panel = this.nextElementSibling;
          if (panel && panel.classList.contains('goa-red-sci-acc__panel')) {
            panel.style.maxHeight = panel.scrollHeight + 'px';
          }
        }
      });

      // Open first by default
      if (i === 0) {
        triggers[i].classList.add('active');
        var panel = triggers[i].nextElementSibling;
        if (panel && panel.classList.contains('goa-red-sci-acc__panel')) {
          panel.style.maxHeight = panel.scrollHeight + 'px';
        }
      }
    }
  });
}

document.addEventListener('shopify:section:load', initGoaRedSciAccPanels);

function initGoaRedQnaPanels() {
  var containers = document.querySelectorAll('[data-goa-red-qna]');
  containers.forEach(function (container) {
    var triggers = container.querySelectorAll('label.goa-red-qna__question');
    for (var i = 0; i < triggers.length; i++) {
      if (triggers[i].dataset.goaQnaPanelInit === '1') continue;
      triggers[i].dataset.goaQnaPanelInit = '1';
      triggers[i].addEventListener('click', function (e) {
        e.preventDefault();
        var isActive = this.classList.contains('active');
        // Close all in this container
        triggers.forEach(function (t) {
          t.classList.remove('active');
          var p = t.nextElementSibling;
          if (p && p.classList.contains('goa-red-qna__panel')) p.style.maxHeight = null;
        });
        // Open clicked if it wasn't already active
        if (!isActive) {
          this.classList.add('active');
          var panel = this.nextElementSibling;
          if (panel && panel.classList.contains('goa-red-qna__panel')) {
            panel.style.maxHeight = panel.scrollHeight + 'px';
          }
        }
      });

      // Open first by default
      if (i === 0) {
        triggers[i].classList.add('active');
        var panel = triggers[i].nextElementSibling;
        if (panel && panel.classList.contains('goa-red-qna__panel')) {
          panel.style.maxHeight = panel.scrollHeight + 'px';
        }
      }
    }
  });
}

document.addEventListener('shopify:section:load', initGoaRedQnaPanels);

window.addEventListener('DOMContentLoaded', function () {
  initGoaRedSciAccPanels();
  initGoaRedQnaPanels();

  const select = document.querySelector('select.smartrr-plan-active');
  if (select) {
    select.value = '601456705'; // Value for "Deliver Every 3 months"
  }
});

